//constants

//Define Console.log for browsers that does not support
if(typeof(console) === 'undefined') {
    var console = {}
    console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time = console.timeEnd = console.assert = console.profile = function() {};
}

var B_ID = 0; APP_TYPE = 1; TOUR_VAL = 2; META_VAL = 3;
var TRADE=0, SHIP=1, C_DUR=2, PORT=3, DATE=4, T_SEQ=5, SUB_T=6, T_DUR=7, PPAX=8, META=9, NO_PAX=10, NUM_PARAMS = 11;
	
var cSelectionsColor = '#769ABC';
var cOptionColor = '#DDE6EE';
var tSelectionsColor = '#7C9949';
var tOptionColor = '#E6ECDD';
	
var params = new Array(NUM_PARAMS);
var gA = new Array(NUM_PARAMS);

var type = "cruises";

var simpleMonth=''; var simpleYear='';

$(document).ready(function() {

	var engineDetails = (getBookingEngineDetails()).split(',');

	resType = engineDetails[APP_TYPE];
	engineId = engineDetails[B_ID];
	defaultMeta = engineDetails[META_VAL];

	cruisedBefore( '#cruised-with-princess' );

	if( resType != 'C' && resType == 'T' ){
		type = "cruisetours";
		cruisedBefore( '#cruised-with-princess-tours' );
	}
	clearQueryParams();
	XML_url = getQueryString( resType, engineId );
	
    $('#search-tabs a.active').click(function(){
    		return false;
    });
	
	$("#cruised-with-princess, #cruised-with-princess-tours").change( function(){
		document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=localhost; ";
		document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=.princess.com; ";
	})

	$(document).on('click','#view', function(){
		viewDetails();
		//return false;
	})
	
	$(document).on('click', '#clear, .clear-button, #clear-button', function(){
		clearAll();
		return false;
	})
	
	$('#error-msg img').click(function(){
		$('#searchlite-error,#error-msg ').hide();
		$('#error-msg p').remove();
		fetchResults( );
	});

	$('.save-to-myprincess').click( function(){
		var target = $(this);
		var voyage = $(this).closest('.results-node').find('span.inactive');
		if( voyage.length == 0 ){
			voyage = $(this).closest('.results-node').find('span.depart-date');
		}
		var className=$(this).attr("class");		
		var voyageId = voyage.attr('data-voyage-id');
		if($(this).hasClass('inactive')){
			portfolioURL = '/removeCruise.rdat?cruiseId='+voyageId+'&source=findandcompare';
		}else{			
			portfolioURL = '/saveToPortfolio.rdat?cruiseId='+voyageId;
		}
		srcURL+= encodeURIComponent("&cruiseId=")+ voyageId;
		if( resType == 'T' ){
			srcURL+= encodeURIComponent("&tourId=")+voyage.attr('data-tour-id')+ encodeURIComponent("&tourStartDate=") + voyage.attr('data-date');  
			portfolioURL +="&tourId="+voyage.attr('data-tour-id')+"&tourStartDate="+voyage.attr('data-date-format');
			
		}
		
		if(!hasLoggedIn()) {
			location.href = $bookURL+'/captaincircle/jsp/userLogin.jsp?srcURL='+srcURL+'&rand='+(new Date()).getTime();	
		}else{
			$.ajax({
				type: "GET",
				cache: false,
				url: portfolioURL,
				dataType: "html",
				success: function( results ){
					if(target.hasClass('inactive')){
						target.removeClass('inactive');
						target.html('Save to My Princess');
					}else{
						target.addClass('inactive');
						target.html('Saved to My Princess');
					}
				},
				error: function(req,error){
					if(error === 'error'){error = req.statusText;}
						alert('An error has occurred.');
				}
			});
		}
		
	});	

}); //Document.Ready Ends

function getData( callBack, type, target ){
	
	//console.log('getData:type='+type);
	$.ajax({
		type: "GET",
		url: XML_url+"&rand="+(new Date()).getTime(),
		dataType: ($.browser.msie) ? "text" : "xml",
		success: function(xml){
			processData( callBack, xml, type, target );
		},
		error: function(req,error){
			if(error === 'error'){error = req.statusText;}
				showError('An error has occurred.');
		}
	});

}

function processData( callBack, xml, type, target ){
	//console.log('processData:type='+type);		
	if($.browser.msie){
		var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
		xmlDoc.loadXML(xml);
		xml = xmlDoc;
	}
	$(xml).find('cruisedata').each(function(){ //Total Cruise
		total = $(this).find('COUNT').text();
		total == 1 ? $('.result-text').text('Itinerary') : $('.result-text').text('Itineraries'); 
		$('.result-count').text(total);
		//console.log("target="+target);
	});
	
	if($.isFunction(callBack)){
		//console.log(callBack);
		callBack.call(this, xml, type );	
	}
}

function getTwoDigitMonth(){
	var d = new Date();
	var month = d.getMonth();
	return ( month < 10 ) ? '0'+month : month;
}

function getTwoDigitYear(){
	var d = new Date();
	return d.getFullYear().toString().substring(2,d.getFullYear().toString().length);
}

function checkStartMonth()	{
	num = Math.floor(curr_month/4)*4;
	return num;
}
	
function getSearchTimeParam(){
	dt = new Date();
	return "time="+dt.getDate()+dt.getMonth();
}

function getSearchPrefix( resType ){
	prefix=(window.location.protocol=="https:")?"/util/cruiseOptions.page?":(resType)=='C' ? "/find/cruiseOptions.do?" : "/find/tourOptions.do?";
	return prefix;
}

function getQueryString( resType, engineId ){
	return 	getSearchPrefix(resType) + getQueryParams() + "&resType="+resType+"&bID="+engineId+"&pageOffset="
}

function clearQueryParams(){
	for( i = 0 ; i < NUM_PARAMS; i++ ){
		params[i] = '';
		gA[i]='';
	}
}

function setClick( type ){
	//SELECT
	$(document).on('click', '#'+type+' li.default', function(e) {
		if( !$(this).hasClass('selected')){
			$(this).addClass('selected');
			if($(this).next('li').children('ul').attr('id')=='sub-trade'){ //Highlighting Sub trade
				$('#sub-trade li').addClass('selected');
				$('#sub-trade').css('background','#ADB2A6');
			}
			if( $(this).parent().attr('id')=='sub-trade' ){
				handleSubtrade( $(this), 'add' );
				$('#sub-trade').css('background','#ADB2A6');
				
			}
		}
		else{ //DESELECT
			$(this).removeClass('selected'); 
			if($(this).next('li').children('ul').attr('id')=='sub-trade'){
				$('#sub-trade li[class*="selected"]').removeClass('selected'); 
				$('#sub-trade').css('background','#F0F3EA');
			}
			if( $(this).parent().attr('id')=='sub-trade' ){
				if( $(this).siblings('.selected').length == 0 ){
					handleSubtrade( $(this), 'remove' );
					$('#sub-trade').css('background','#F0F3EA');
				}
			}
		}	
		sendQuery( update, type );	
	});
}

function populateConditionalParams(){
	var isSearchFilter = $('#search-filters').length ? true : false; 
	
	//Get Past Pax
 	gA[PPAX] = params[PPAX] = $('#cruised-with-princess:checked, #personal-pricing:checked').length == 1 ? 'true' : '';
 	
 	//Get Meta
 	var meta  = $('#'+type+' input[name=meta]:checked, select[name=meta] option:selected').val();
 	if( isSearchFilter ){
 		meta = $('.select-room-type input[name=meta]:checked').val();
 	}
 	gA[META] = params[META] = ( typeof meta === 'undefined' || meta.length > 1 ) ? defaultMeta : meta;
	gA[META] = 'Meta-'+gA[META];
	
	//Get No Of Pax
	var numPax = $('select[name=noOfPax] option:selected').val();
	gA[NO_PAX] = params[NO_PAX]  = ( typeof numPax === 'undefined' ) ? 2 : numPax;

}

function viewDetails(){
	var isSearchFilter = $('#search-filters').length ? true : false; 
	prepQuery();
	populateConditionalParams();
	//console.log(getQueryParams());
        if(window.location.protocol=="https:")
                window.open("http://www.princess.com/find/searchResults.do?"+ getQueryParams() + "&resType="+resType+"&bID="+engineId+"&pageOffset=");
        else
                location.href="/find/searchResults.do?"+ getQueryParams() + "&resType="+resType+"&bID="+engineId+"&pageOffset=";
}

function getQueryParams( ){
	if( (simpleMonth != ''  &&  simpleYear != '') ){
		if( (simpleMonth+simpleYear).toString() != 'XXXX' ){
			params[DATE] = simpleMonth+simpleYear ;
		}
	}
	if( typeof params[DATE] != 'undefined' || params[DATE] != '' ){
		var thisMonth = getTwoDigitMonth();
		var thisYear = getTwoDigitYear();
		var dates = params[DATE].split(',');
	
		if( $.inArray(thisMonth+thisYear, dates) > -1 ){
			dates = dates.slice($.inArray(thisMonth+thisYear, dates));
		}
		params[DATE] = dates.join();
	}
	
	var query = '&trade=%s&ship=%s&duration=%s&port=%s&date=%s&order=%s&filterBy=%s&tourdur=%s&ppax=%s&meta=%s&noOfPax=%s';
	return getSearchTimeParam()+$.sprintf(query, params[TRADE], params[SHIP], params[C_DUR], params[PORT], params[DATE], params[T_SEQ], params[SUB_T], params[T_DUR], params[PPAX], params[META], params[NO_PAX] );
}

function removeLastComma( arr ){
	for( i = 0 ; i < arr.length; i++ )
		arr[i] = arr[i].substring(0, arr[i].lastIndexOf(','));
	return arr;
}

function showError( msg ){
	$('#error-msg').prepend('<p>'+msg+'</p>');
	$('#searchlite-error, #error-msg').show();
}

function sendQuery( callback, type, target  ){ // Update and send query on every item click
	prepQuery();
	//console.log('sendQuery:type='+type);
	getData( callback, type, target );
	
}

function prepQuery( ){
	XML_url ="";
	clearQueryParams();
	getSelections($('#'+type+' [class*="selected"]'));
	params = removeLastComma( params );
	gA = removeLastComma( gA );
 	XML_url = getQueryString( resType, engineId );
}

function buildDates( cruise, cruiseTours, optElementType ){
	d = new Date();
  	curr_month = d.getMonth();
  	curr_year = d.getFullYear();
  	month_names =[ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
  	monthStart = monthCounter = checkStartMonth();
  	totalMonths = 32;
  	totalMonthsCounter = 0;
  	var yearText1, yearText2, yearText3; 
  	
  	dateTag = ( optElementType != 'input' )? 'h3' : 'dt';
  	
  	$('.dates '+dateTag+'[data-year="year_1"]').append(curr_year);
  	$('.dates '+dateTag+'[data-year="year_2"]').append(curr_year+1);
  	$('.dates '+dateTag+'[data-year="year_3"]').append(curr_year+2);
  	yearText1= $('.dates '+dateTag+'[data-year="year_1"]').text().substring(2,4);
  	yearText2= $('.dates '+dateTag+'[data-year="year_2"]').text().substring(2,4);
  	yearText3= $('.dates '+dateTag+'[data-year="year_3"]').text().substring(2,4);
  	
  	
  	$.each(month_names, function(i){
	  	if( monthStart > i ){
		  	return true;
		}
	  	var j = i+1;
	  	if(j<=9){ j="0"+j}

		if( optElementType != 'input' ){
	  		$(cruise+' .dates ul.months_1').append('<li id="D'+[j] + yearText1  +'">'+ month_names[monthCounter] +'</li>');
	  		if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates ul.months_1').append('<li id=TD'+[j] + yearText1  +'>'+ month_names[monthCounter] +'</li>');
	  		}
	  	}
		else{
			$(cruise+' .dates dl.months_1').append('<dd><input type="checkbox" id="D'+[j] + yearText1  +'" value="'+[j] + yearText1+'"><label for="D'+[j] + yearText1  +'">'+month_names[monthCounter]+'</label></dd>');
			if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates dl.months_1').append('<dd><input type="checkbox" id="TD'+[j] + yearText1  +'" value="'+[j] + yearText1+'"><label for="TD'+[j] + yearText1  +'">'+month_names[monthCounter]+'</label></dd>');
	  		}
	  	}
	  	monthCounter++;
	  	totalMonthsCounter++;
	  	return(monthCounter != 12);
  	});

  	monthCounter = 0;
  	$.each(month_names, function(i){
	  	var j = i+1;
	  	if(j<=9){ j="0"+j}
		
		if( optElementType != 'input' ){
	  		$(cruise+' .dates ul.months_2').append('<li id="D'+[j] + yearText2  +'">'+ month_names[monthCounter] +'</li>');
	  		if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates ul.months_2').append('<li id="TD'+[j] + yearText2  +'">'+ month_names[monthCounter] +'</li>');
	  		}
	  	}
	  	else{
	  		$(cruise+' .dates dl.months_2').append('<dd><input type="checkbox" id="D'+[j] + yearText2 +'" value="'+[j] + yearText2+'"><label for="D'+[j] + yearText2  +'">'+month_names[monthCounter]+'</label></dd>');
	  		if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates dl.months_2').append('<dd><input type="checkbox" id="TD'+[j] + yearText2  +'" value="'+[j] + yearText2+'"><label for="TD'+[j] + yearText2  +'">'+month_names[monthCounter]+'</label></dd>');
	  		}
	  	}
	  	monthCounter++;
	  	totalMonthsCounter++;
	  	return(monthCounter != 12);
  	});
  	
  	monthCounter = 0;
  	$.each(month_names, function(i){
		var j = i+1;
	  	if(j<=9){ j="0"+j}
	
		if( optElementType != 'input' ){
	  		$(cruise+' .dates ul.months_3').append('<li id="D'+[j] + yearText3  +'">'+ month_names[monthCounter] +'</li>');
	  		if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates ul.months_3').append('<li id="TD'+[j] + yearText3 +'">'+ month_names[monthCounter] +'</li>');
	  		}
	  	}
	  	else{
	  		$(cruise+' .dates dl.months_3').append('<dd><input type="checkbox" id="D'+[j] + yearText3  +'" value="'+[j] + yearText3+'"><label for="D'+[j] + yearText3  +'">'+month_names[monthCounter]+'</label></dd>');
	  		if( typeof cruiseTours != "undefined" && cruiseTours != "" ){
	  			$(cruiseTours+' .dates dl.months_3').append('<dd><input type="checkbox" id="TD'+[j] + yearText3  +'" value="'+[j] + yearText3+'"><label for="TD'+[j] + yearText3  +'">'+month_names[monthCounter]+'</label></dd>');
	  		}
	  	
	  	}
	  	monthCounter++;
	  	totalMonthsCounter++;
	  	return(totalMonthsCounter != totalMonths);
  	});	
  	
	
}
function getSelections( elems ){
	elems.each( function(i) {
		selectedText = $.trim($(this).text());
		if( $(this).is('input:checkbox') ){
			selectedText = $.trim($(this).next().text());
		}
		selectedId = $(this).attr('id');
		if( typeof selectedId != "undefined" ){
			if( selectedId.match(/^T[A-Z]{1}$/) || selectedId.match(/^M[A-Z]{1}$/) ){ //TRADE 
				params[TRADE] += selectedId.charAt(1)+',';
				gA[TRADE] += (selectedText.replace(/ /g,'')).replace(/\&|\,/g,'-')+',';
				return;
			}
			if( selectedId.match(/^P[0123]{1}$/) ){ //DURATION
				params[C_DUR] += selectedId.substring(1,selectedId.length)+','; 
				gA[C_DUR] += selectedText+',';
				return;
			}
	
			/***************************************************************/
			if( selectedId.match(/^E[A-Z0-9]{3}$/) ){ //PORT
				params[PORT] += selectedId.substring(1,selectedId.length)+',';
				gA[PORT] += (selectedText.replace(/ /g,'')).replace(/\&|\,/g,'-')+',';
				return; 
			}
			if( selectedId.match(/^TE[A-Z0-9]{3}$/) ){ //PORT
				params[PORT] += selectedId.substring(2,selectedId.length)+',';
				gA[PORT] += (selectedText.replace(/ /g,'')).replace(/\&|\,/g,'-')+',';
				return; 
			}
			if( selectedId.match(/^D[0-9]{4}$/) ){ //DATE
				params[DATE] += selectedId.substring(1,selectedId.length)+',';
				gA[DATE] += selectedText + selectedId.substring(3,selectedId.length) + ',';
				return; 
			}
			if( selectedId.match(/^TD[0-9]{4}$/) ){ //DATE
				params[DATE] += selectedId.substring(2,selectedId.length)+',';
				gA[DATE] += selectedText + selectedId.substring(4,selectedId.length) + ',';
				return; 
			}
			if( selectedId.match(/^S[A-Z]{2}$/) ){ //SHIP
				params[SHIP] += selectedId.substring(1,selectedId.length)+',';
				gA[SHIP] += selectedText.replace(/ /g,'')+',';
				return;
			}
			if( selectedId.match(/^TS[A-Z]{2}$/) ){ //SHIP
				params[SHIP] += selectedId.substring(2,selectedId.length)+',';
				gA[SHIP] += selectedText.replace(/ /g,'')+',';
				return;
			}
			/*******************************************************************/
			
			if( selectedId.match(/^M[A-Z]{3}$/) ){ //SUBTRADE
				params[SUB_T] += selectedId.substring(1,selectedId.length)+',';
				gA[SUB_T] += selectedText+',';
				return;
			}
			if( selectedId.match(/^R[356]{1}$/) ){ //TOUR DURATION
				params[T_DUR] += selectedId.charAt(1)+',';
				gA[T_DUR] += selectedText+',';
				return;
			}
			if( selectedId.match(/^C[123]{1}$/) ){ //CRUISE DURATION
				params[C_DUR] += selectedId.charAt(1)+',';
				gA[C_DUR] += selectedText+',';
				return;
			}
			if( selectedId.match(/^O[AB]{1}$/) ){ //TRAVEL SEQUENCE
				params[T_SEQ] += selectedId.charAt(1)+',';
				gA[T_SEQ] += selectedText.replace(/\,/g,'')+',';
				return;
			}
			if( selectedId.match(/^DM[0-9A-Z]{2}$/) ){ //DATE MONTH
				simpleMonth = selectedId.substring(2,selectedId.length);
				var date = '';
				if(simpleMonth == 'XX' ){
					if($('#year option.empty-opt:selected').length == 0 ){
						var d = new Date();
						var thisMonth = ( d.getMonth() < 10 ) ? '0'+(d.getMonth()+1) : d.getMonth()+1;
						var monthIndex = $('#month option').index($('#DM'+thisMonth));
						console.log(monthIndex);
						$('#month option').not('.empty-opt').each(function(i){
							console.log(i + " "+monthIndex);
							if( i >= monthIndex  ){
								console.log("in here: "+date)
								date += $(this).attr('id').substring(2,$(this).attr('id').length)+ simpleYear +','
							}
						});
						simpleMonth = '';
					}
					params[DATE] = date;
					gA[DATE] = date;
					return;
				}
				$('#year option').not('.empty-opt').each(function(){
					date += simpleMonth + $(this).attr('id').substring(2,$(this).attr('id').length)+',';
				});
				params[DATE] = date;
				gA[DATE] = date;
				return;			
			}
			if( selectedId.match(/^DY[0-9A-Z]{2}$/) ){ //DATE YEAR
				simpleYear = selectedId.substring(2,selectedId.length);
				var date = '';
				if(simpleYear == 'XX' ){
					if($('#month option.empty-opt:selected').length == 0 ){
						$('#year option').not('.empty-opt').each(function(){
							date += simpleMonth + $(this).attr('id').substring(2,$(this).attr('id').length)+','	
							//console.log("here1")
						});
						simpleYear = '';
					}
					params[DATE] = date;
					gA[DATE] = date;
					return;	
				}
				$('#month option').not('.empty-opt').each(function(){
					date += $(this).attr('id').substring(2,$(this).attr('id').length)+ simpleYear +',';
					//console.log("here2");
				});
				params[DATE] = date;
				gA[DATE] = date;
				return;
			}
		}
 	});

}

function cruisedBefore( selector ){
	if( getCookie("cwp") != undefined && getCookie("cwp") != "" ){
		var cruisedBefore = $(selector);
		//console.log(cruisedBefore);
		cruisedBefore.val(getCookie("cwp"));
		cruisedBefore.each(function(){
			if( $(this).val() == "true" ){
				$(this).attr('checked',true);
			}
			else{
				$(this).val('false');
				$(this).attr('checked',false);
			}
		});
	}
	else{
		document.cookie = 'cwp' + "=" + escape($(selector).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=localhost; ";
		document.cookie = 'cwp' + "=" + escape($(selector).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=.princess.com; ";
	}
	
 	
}
function getFnCPageLocation(){
	var loc = ( type.indexOf('find-cruise') > -1 || $('#find-compare').length == 1 || type.indexOf('quick-search') > -1  ) ? "RecentlyViewed" : "SearchResults";
	return loc;
}

function initCap(str) {
	 var str = str.substring(0,1).toUpperCase() + str.substring(1,str.length).toLowerCase();
	 return str;
}

$.fn.hideOption = function() {
    this.each(function() {
        if ($(this).is('option') && (!$(this).parent().is('span'))) {
            $(this).wrap('<span>').hide()
        }
    });
}

$.fn.showOption = function() {
    this.each(function() {
        if (this.nodeName.toLowerCase() === 'option') {
            var p = $(this).parent('span'),
                o = this;
            $(o).show();
            $(p).replaceWith(o)
        } else {
            var opt = $('option', $(this));
            $(this).replaceWith(opt);
            opt.show();
        }
    });
}

